var styles = {"container":"video-page--container","videojs-container":"video-page--videojs-container","heading":"video-page--heading","subheading":"video-page--subheading"};

export { styles as default };
//# sourceMappingURL=VideoPage.module.esm.js.map
